/**
 * Sayı yazımı arayüz diline göre: Türkçede "1.234,5", İngilizcede "1,234.5".
 * Dil `i18next` örneğinden okunur; bileşen dışındaki yardımcılar da kullanabilsin
 * diye kanca değil düz fonksiyon.
 */
import i18n from "../../i18next";

export const yerel = () => (i18n.language === "en" ? "en-US" : "tr-TR");

/** Boş ya da sayı olmayan değer "–" yazılır. */
export const sayiYaz = (v, basamak = 0) =>
  v == null || v === "" || Number.isNaN(Number(v))
    ? "–"
    : Number(v).toLocaleString(yerel(), { maximumFractionDigits: basamak });
